import { render, staticRenderFns } from "./PayCard.vue?vue&type=template&id=240af88d&scoped=true"
import script from "./PayCard.vue?vue&type=script&lang=js"
export * from "./PayCard.vue?vue&type=script&lang=js"
import style0 from "./PayCard.vue?vue&type=style&index=0&id=240af88d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_cache-loader@4.1.0_webpack@4.47.0_supports-_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240af88d",
  null
  
)

export default component.exports